import { useContext } from 'react';
import ProductPageContext from '../contexts/ProductPageContext';
import SwitchTestContext from '../contexts/SwitchTestContext';

export default function useHasGoldenStateAnalytics() {
  const ProductPageState = useContext(ProductPageContext);
  const SwitchTestState = useContext(SwitchTestContext);

  const hasGoldenStateAnalytics = !!SwitchTestState['pdp-has-universal-click-golden-state-analytics'];
  const isQuickview = !!ProductPageState?.isQuickview;

  return hasGoldenStateAnalytics || isQuickview;
}
